<template>
    <div class="w-full bg-gray-200 min-h-screen">

        <div class="text-left px-4 py-4 bg-gray-400 sticky top-0 z-50 w-full flex items-center justify-between">
            <div @click="cancel" class="flex items-center">

                <IconChevronLeftOutline class="w-8 h-8 mr-2"></IconChevronLeftOutline>
                {{_('Return to menu') }}

            </div>

<!--            <button class="block bg-red-700  px-6 rounded shadow mr-4" :class="submitting ? 'text-red-200 py-0 pl-1' : 'text-white py-2'" :disabled="submitting" @click="submit" type="button">-->
<!--                <template v-if="submitting">-->
<!--                    <img :src="loading" class="inline-block mr-2 w-10 h-10">-->
<!--                </template>-->
<!--                Ajouter</button>-->

            <div class="text-2xl font-bold">$ {{ price }}</div>
            
        </div>
        
        


        <div class="mx-auto w-75 mb-3 p-3 border">
            <h2 class="text-2xl font-bold my-1">{{ original.name }}</h2>
            <p class="text-sm text-gray-900">{{ original.description }}</p>

            <template v-if="original.image!==''&&original.image!==null">
                <img :src="cdn(original.image)" class="max-w-lg w-full mx-auto mt-2" />
            </template>

<!--            <div class="my-4 text-2xl font-bold text-right">$ {{ price }}</div>-->


            <div v-for="(option, idx) in item.options"  :key="idx" v-if="isVisible(option)"  class="mb-4">
                <h3 class="font-bold mb-2">{{ option.title }}
                    <span v-if="!option.required" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">Optionnel</span>
                </h3>

                <div v-if="req&&!isValid(idx)" :ref="`required_${idx}`" class="bg-red-500 text-white p-2 px-4 rounded my-1">
                    {{_('This field is required. Please make a choice.')}}
                </div>


                <div class="" v-if="option.type==='FIELD'">
                    <input type="text" v-model="selection[idx]" :placeholder="option.values[0].label" class="block w-full border border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight mb-2" />
                </div>

                <div class="inline-block relative w-full" v-if="option.type==='DROPDOWN'">

                    <select v-model="selection[idx]" class="form-control block appearance-none w-full bg-white border border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:ring">
                        <option value="">-- Faites-un choix --</option>
                        <option v-for="value in activeValues(option)" :value="`${option.id}.${value.id}`" :key="`${option.id}.${value.id}`">
                            {{ value.label }} {{ (value.price && value.price > 0) ? `$ ${value.price.toFixed(2)}` : '' }}
                        </option>
                    </select>

<!--                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">-->
<!--                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>-->
<!--                    </div>-->
                </div>

                <item-selector-checkbox v-if="option.type==='CHECKBOX'" v-model="selection[idx]" :values="activeValues(option)" :option="option">
                </item-selector-checkbox>

                <item-selector-quantity v-if="option.type==='QUANTITY'" v-model="selection[idx]" :values="activeValues(option)" :option="option">
                </item-selector-quantity>

                <item-selector-radio v-if="option.type==='RADIO'" v-model="selection[idx]" :values="activeValues(option)" :option="option">
                </item-selector-radio>

            </div>


            <div v-if="comments_disabled">
<!--                nothing here -->
            </div>
            <div v-else>
                <textarea v-model="comments" rows="5" class="form-control block appearance-none w-full bg-white border border-gray-400 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:ring" :placeholder="_('This field is reserved for omissions or special instructions that do not have extra cost. We cannot guarantee the requests.')"></textarea>
            </div>

            <div class="mt-4 " v-if="is_open">

                    <button class="block bg-red-700 w-full px-6 rounded shadow mr-4" :class="submitting ? 'text-red-200 py-0 pl-1' : 'text-white py-2'" :disabled="submitting" @click="submit" type="button">
                        <template v-if="submitting">
                            <img :src="loading" class="inline-block mr-2 w-10 h-10">
                        </template>
                        
                        <template v-if="submission!==null">
                            {{ _('Edit') }}
                        </template>
                        <template v-else>
                            {{ _('Add') }}
                        </template>
                        </button>
<!--                    <button type="button" @click="cancel">Retour au menu</button>-->

            </div>

        </div>
    </div>
</template>

<script>


import ItemSelectorCheckbox from "./ItemSelectorCheckbox";
import ItemSelectorQuantity from "./ItemSelectorQuantity";
import ItemSelectorRadio from "./ItemSelectorRadio";
    import gif from '../../images/loading.gif';
import IconArrowLeftOutline from "../../icons/outline/IconArrowLeftOutline";
import IconChevronLeftOutline from "../../icons/outline/IconChevronLeftOutline";
import Vue from "vue";
import {lang} from "../lang";
    export default {
        name: "ItemSelector",
        components: {
            IconChevronLeftOutline,
            IconArrowLeftOutline, ItemSelectorCheckbox, ItemSelectorQuantity, ItemSelectorRadio},
        props: [
            'app_locale', 'is_open', 'comments_disabled',
            'item', 'original', 'ingredients', 'live', 'submit_url', 'return_url', 'submission_id', 'item_id', 'post_id', 'submission'],
        data() {
            const mult = (val, amount) => {
                let arr = [];
                for (let i = 0; i < amount; i++) {
                    arr.push(val);
                }
                return arr;
            };
            
            return {
                sid: this.submission_id,
                comments: (this.submission && this.submission) ? this.submission.comments : '',
                req: false,
                submitting: false,
                loading: gif,
                selection: this.submission ? this.submission.selection : this.item.options.map(opt => {
                    let val = (opt.type === 'CHECKBOX' || opt.type === 'QUANTITY') ? [] : '';
                    if (opt.default !== null && opt.default !== undefined) {
                        if (opt.type === 'CHECKBOX') {
                            if (typeof opt.default === 'object') {
                                val = opt.default.map((val, index) => val ? index : false).filter((e, i) => e !== false && i < opt.values.length).map(index => `${opt.id}.${opt.values[index].id}`);
                            } else {
                                val = [];
                            }
                        } else if (opt.type === 'QUANTITY') {
                            if (typeof opt.default === 'object') {
                                val = opt.default.flatMap((val, index) => val ? mult(index, val) : false).filter(e => e !== false).map(index => `${opt.id}.${opt.values[index].id}`);
                            } else {
                                val= [];
                            }
                        } else if (opt.values[opt.default]) {
                            val = `${opt.id}.${opt.values[opt.default].id}`;
                        }

                    }

                    return val;
                }),
            };
        },

        mounted() {
            // console.log(this.selection);
        },
        
        watch: {
            item: {
                deep: true,
                handler() {
                    const mult = (val, amount) => {
                        let arr = [];
                        for (let i = 0; i < amount; i++) {
                            arr.push(val);
                        }
                        return arr;
                    };
                    this.selection = this.item.options.map(opt => {
                        let val = (opt.type === 'CHECKBOX' || opt.type === 'QUANTITY') ? [] : '';
                        if (opt.default !== null && opt.default !== undefined) {
                            if (opt.type === 'CHECKBOX') {
                                if (typeof opt.default === 'object') {
                                    val = opt.default.map((val, index) => val ? index : false).filter((e, i) => e !== false && i < opt.values.length).map(index => `${opt.id}.${opt.values[index].id}`);
                                } else {
                                    val = [];
                                }
                            } else if (opt.type === 'QUANTITY') {
                                if (typeof opt.default === 'object') {
                                    val = opt.default.flatMap((val, index) => val ? mult(index, val) : false).filter(e => e !== false).map(index => `${opt.id}.${opt.values[index].id}`);
                                } else {
                                    val= [];
                                }
                            } else if (opt.values[opt.default]) {
                                val = `${opt.id}.${opt.values[opt.default].id}`;
                            }

                        }

                        return val;
                    })
                }
            }
        },

        computed: {

            price() {
                return this.selection ?  this.selection.map((selection, index) => {
                    if (!this.isVisible(this.item.options[index])) {
                        return 0;
                    }
                    if (this.item.options[index].type === 'CHECKBOX') {
                        return selection.map(id => {
                            let item = this.valueFor(id, index);
                            return item ? (1 * item.price) : 0;
                        }).reduce((c, v) => c + v, 0);

                    } else if (this.item.options[index].type === 'QUANTITY') {
                        let limit = 0;
                        if (this.item.options[index].limit > 0 && this.item.options[index].hardlimit === false) {
                            limit = 1 * this.item.options[index].limit;
                        }
                        return selection.map((id, idx) => {
                            let item = this.valueFor(id, index);
                            return item ? (limit === 0 || idx >= limit ? 1 * item.price : 0) : 0;
                        }).reduce((c, v) => c + v, 0);
                    } else if (this.item.options[index].type === 'FIELD') {
                        return isNaN(1 * selection) ? 0 : 1 * selection;
                    } else {
                        let item = this.valueFor(selection, index);
                        return item ? (1 * item.price) : 0;
                    }
                }).reduce((carry, price) => carry + price, (1 * this.item.price)).toFixed(2) : 0;
            },

            remarks() {
                let body = ''; // `$${this.item.price}\n`;
                if (!this.selection) {
                    return body;
                }
                this.item.options.forEach((option, index) => {
                    if (!this.isVisible(option)) {
                        return;
                    }
                    const sel = this.selection[index];
                    if (option.type === 'CHECKBOX') {
                        sel.forEach(s => {
                            let item = this.valueFor(s, index);
                            if (item) {
                                body += `${item.label} ` + (item.price ? `$${item.price}` : '') + "\n";
                            }
                        })
                    } else if (option.type === 'QUANTITY') {
                        let packs = {};
                        let limit = 0;
                        if (option.limit > 0 && option.hardlimit === false) {
                            limit = 1 * option.limit;
                        }
                        sel.forEach((s, idx) => {
                            let item = this.valueFor(s, index);
                            if (item) {
                                if (packs[s] === undefined) {
                                    packs[s] = [];
                                }
                                const price = (limit === 0 || idx >= limit ? 1 * item.price : 0);

                                packs[s].push([item.label, price]);
                            }
                        })

                        for (var i in packs) {
                            const pack = packs[i];
                            pack.forEach(p => {
                                body += `${p[0]} ` + (p[1] > 0 ? `$${p[1]}` : '') + "\n";
                            });
                        }

                    } else if (option.type === 'FIELD') {
                        body += `${option.title}  $${sel} \n`;
                    } else {
                        let item = this.valueFor(sel, index);
                        if (item) {
                            body += `${item.label} ` + (item.price ? `$${item.price}` : '') + "\n";
                        }
                    }
                })

                if (this.comments && this.comments !== '') {
                    body += `\n${this.comments.split('$').join('')}`;
                }
                return body;
            },

            raw_remarks() {
                let body = [];
                if (!this.selection) {
                    return body;
                }
                this.item.options.forEach((option, index) => {
                    if (!this.isVisible(option)) {
                        return;
                    }
                    const sel = this.selection[index];
                    if (option.type === 'CHECKBOX') {
                        sel.forEach(s => {
                            let item = this.valueFor(s, index);
                            if (item) {
                                body.push(`${item.label} ` + (item.price && !isNaN(item.price) ? `$${item.price.toFixed(2)}` : ''));
                            }
                        })
                    } else if (option.type === 'QUANTITY') {
                        let packs = {};
                        let limit = 0;
                        if (option.limit > 0 && option.hardlimit === false) {
                            limit = 1 * option.limit;
                        }
                        sel.forEach((s, idx) => {
                            let item = this.valueFor(s, index);
                            if (item) {
                                if (packs[s] === undefined) {
                                    packs[s] = [];
                                }
                                const price = (limit === 0 || idx >= limit ? 1 * item.price : 0);

                                packs[s].push([item.label, price.toFixed(2)]);
                            }
                        })

                        for (var i in packs) {
                            const pack = packs[i];
                            pack.forEach(p => {
                                body.push(`${p[0]} ` + (p[1] > 0 ? `$${p[1]}` : ''));
                            });
                        }

                    } else if (option.type === 'FIELD') {
                        body.push(`${option.title}  $${sel}`);
                    } else {
                        let item = this.valueFor(sel, index);
                        if (item) {
                            body.push(`${item.label} ` + (item.price && !isNaN(item.price) ? `$${item.price.toFixed(2)}` : ''));
                        }
                    }
                })

                if (this.comments && this.comments !== '') {
                    body.push("Commentaire:");
                    body.push(`${this.comments.split('$').join('')}`);
                }
                return body;
            }
        },

        methods: {

            activeValues(option) {
                return option.values.filter(opt => this.isActive(opt));
            },
            valueFor(id, index=null) {
                if (!id) {
                    return null;
                }
                const comps = id.split(".");
                if (comps.length !== 2) {
                    return null;
                }
                let option = index !== null ? this.item.options[index] : this.itemFor(comps[0]);
                if (option) {
                    return this.itemFor(comps[1], option.values);
                }
                return null;
            },


            itemFor(id, array) {
                if (array === undefined) {
                    array = this.item.options;
                }
                const items = array.filter(e => e.id == id);
                //console.log(items);
                return items ? items[0] : null;
            },

            isVisible(option) {
                if (option.conditional.length === 0) return true;

                // "$"-prefixed tokens are AND/required: every one must match.
                if (option.conditional.filter(c => c.substr(0, 1) === '$').reduce((c, condition) => {
                    return c && this.applyCondition(condition.substr(1));
                }, true ) === false) {
                    return false;
                }

                // Plain tokens are OR: at least one must match. If there are none,
                // the required (AND) checks above are sufficient.
                const optional = option.conditional.filter(c => c.substr(0, 1) !== '$');
                if (optional.length === 0) return true;

                return optional.reduce((c, condition) => {
                    return c || this.applyCondition(condition);
                }, false);
            },

            isFullOrPartialMatch(target, check) {
                const parts = check.split(".");
                const parts2 = target.split(".");
                if (parts.length === 2 && parts[1] === '*' && parts2.length === 2) {
                    return parts2[0] === parts[0];
                } else {
                    return target === check;
                }
            },

            applyCondition(condition) {
                return this.selection.filter(sel => sel !== null).filter(sel => 
                    typeof sel === 'string' ? 
                        this.isFullOrPartialMatch(sel, condition) :
                        sel.filter(s => this.isFullOrPartialMatch(s, condition)).length > 0
                ).length > 0;
            },


            ingredientActive(id) {
                return this.ingredients.filter(ing => ing.id === id).filter(ing => ing.active).length > 0;
            },


            isActive(option) {
                if (option.ingredients.length === 0) {
                    return option.active;
                } else {
                    return option.ingredients.map(ing => this.ingredientActive(ing)).filter(act => act).length === option.ingredients.length;
                }
            },

            isValid(index) {
                // Ce champs est nécessaire. Veuillez faire un choix.
                const option = this.item.options[index];
                const selection = this.selection[index];
                // console.log(index, option.required, option.type, selection);
                if (option.required) {
                    return (option.type === 'CHECKBOX' || option.type === 'QUANTITY') ? (selection.length > 0 && selection[0] !== '') : selection !== ''
                }
                return true;
            },

            cancel() {
                if (!this.live) {
                    return;
                }
                if (this.return_url) {
                    window.location = this.return_url;
                } else {
                    this.$emit('cancel');
                }
            },

            submit() {
                if (!this.live) {
                    this.submitting = true;
                    // console.log(this.remarks);
                    setTimeout(() => { this.submitting = false; }, 1000);
                    return;
                }

                // validate
                // console.log(this.selection);
                const valid = this.item.options.map((option, index) => !this.isVisible(option) || this.isValid(index)).reduce((c, e) => c && e, true);
                if (!valid) {
                    // console.log("invalid");
                    this.req = true;
                    Vue.nextTick(() => {
                        const refs = Object.keys(this.$refs).filter(k => k.substr(0, "required_".length) === "required_");
                        if (refs.length > 0) {
                            this.$refs[refs[0]][0].scrollIntoView({block:"center"});
                        }
                        
                    })
                    return;
                }
                
                if (!this.return_url) {
                    
                    this.$emit('submit', {
                        id: this.submission_id,
                        original: this.original,
                        data: {
                            selection: this.selection,
                            usable_selection: this.selection.map((selection, index) => this.isVisible(this.item.options[index]) ? selection :
                                (["CHECKBOX", "QUANTITY"].filter(t => t === this.item.options[index].type).length > 0 ? [] : "")),
                            comments: this.comments,
                            qty: this.submission && this.submission.qty ? this.submission.qty : 1,
                            options: this.item.options
                        },
                        price: this.price,
                        remarks: this.raw_remarks,
                    });
                    return;
                }
                
                // post
                this.submitting = true;
                window.axios.post('/api/submission', {
                    item_id: this.original.id,
                    submission_id: this.sid,
                    data: {selection: this.selection, comments: this.comments},
                    meta: {
                        submit_url: this.submit_url,
                        return_url: this.return_url,
                        item_id: this.item_id,
                        post_id: this.post_id
                    }
                }).then(response => {
                    this.sid = response.data;
                    setTimeout(() => {
                        this.$emit('submit', {
                            total: this.price,
                            remarks: this.remarks,
                            submission_id: this.sid
                        });
                            
                    }, 200);
                }).catch(error => {
                    console.error("There was an error processing this request");
                    this.submitting = false;
                })


            },
            cdn(url) {
                if (url.substr(0, "http".length) === "http") {
                    return url;
                }
                return cdn + url;
            },

            _(k) {
                return lang(k, this.app_locale === 'fr_CA' ? 'fr' : 'en')
            }

        }
    }
</script>

<style scoped>

</style>
